import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "../src/style.css";

// ReactDOM.render is no longer supported in React 18. Use createRoot instead.
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
